import type { LucideIcon } from "lucide-react";
import { ClipboardList, Eye, HandHeart, HeartHandshake, MessagesSquare } from "lucide-react";

export type ChatSituationId = "handover" | "conversation" | "observing" | "practice" | "reflection";

export type ChatSituationTone = "primary" | "warning" | "info" | "success" | "accent";

export type ChatSituation = {
  id: ChatSituationId;
  icon: LucideIcon;
  tone: ChatSituationTone;
};

export const chatSituations: ChatSituation[] = [
  { id: "handover", icon: ClipboardList, tone: "primary" },
  { id: "conversation", icon: MessagesSquare, tone: "warning" },
  { id: "observing", icon: Eye, tone: "info" },
  { id: "practice", icon: HandHeart, tone: "success" },
  { id: "reflection", icon: HeartHandshake, tone: "accent" },
];

export const situationToneClass: Record<ChatSituationTone, string> = {
  primary: "bg-primary/10 text-primary",
  warning: "bg-warning text-warning-foreground",
  info: "bg-info text-info-foreground",
  success: "bg-success text-success-foreground",
  accent: "bg-accent/15 text-accent",
};
